import { ProfileBranding } from '../models/branding.models';

/**
 * Stand-in emitted when the branding fetch fails, so consumers always get something to read. Everything is
 * null because each consumer already supplies its own fallback at the point of use, and picking values here
 * would override those rather than defer to them.
 */
export const DEFAULT_PROFILE_BRANDING: ProfileBranding = {
  avatarImage: null,
  coverImage: null,
  textColour: null,
  primaryColour: null,
  secondaryColour: null,
  squareLogoImage: null,
  rectangleLogoImage: null,
  brandKitId: null,
};
